"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRHeaders = void 0;
var XHRHeaders = /** @class */ (function () {
    function XHRHeaders(headerText) {
        this._headers = {};
        this._init(headerText);
    }
    XHRHeaders.prototype._init = function (headerText) {
        if (headerText) {
            var headerPairs = headerText.split('\u000d\u000a');
            for (var _i = 0, headerPairs_1 = headerPairs; _i < headerPairs_1.length; _i++) {
                var headerPair = headerPairs_1[_i];
                // Can't use split() here because it does the wrong thing
                // if the header value has the string ": " in it.
                var index = headerPair.indexOf('\u003a\u0020');
                if (index > 0) {
                    var key = headerPair.substring(0, index).toLowerCase();
                    var val = headerPair.substring(index + 2);
                    this._headers[key] = val;
                }
            }
        }
    };
    XHRHeaders.prototype.get = function (key) {
        return this._headers[key.toLowerCase()] || null;
    };
    XHRHeaders.prototype.has = function (key) {
        return this._headers.hasOwnProperty(key.toLowerCase());
    };
    return XHRHeaders;
}());
exports.XHRHeaders = XHRHeaders;
//# sourceMappingURL=headers.js.map